export default function getLicense(withSubProduct, formType, product, subProduct, url = 'https://www.starwindsoftware.com/point-form-validation.js') {

    // let url = '';
    let license  = '';
    let category = '';

    let validVSANSubProduct     =  false;
    let validVSANFreeSubProduct = false;
    let validSANNASSubProduct   = false;
    let valid_vHCI_subProduct   = false;

    let Scenario_202306 = '';

    // console.log('getLicense', formType, product, subProduct);

    // switch (formType) {
    //     case 'quote':
    //     case 'pricing':
    //     case 'demo':
    //     case 'download':
    //         // url = 'point-form-validation';
    //         url = 'https://www.starwindsoftware.com/point-form-validation.js';
    //         break;
    // }

    if( formType === 'download' &&  withSubProduct === true ) {
        Scenario_202306 = subProduct;
    }


    switch (product) {


        case 'Virtual Backup Appliance Trial':
        case 'Virtual Backup Appliance Free':
        case 'StarWind x Veeam Hardened Backup Repository':

            Scenario_202306 = subProduct

            break;

        case 'Virtual HCI Appliance (vHCI)':

            // url = '/form-1149-no-hypervisor-v17.js';
            category = 'StarWind VSAN 30-day Trial';

            switch (subProduct) {
                case 'StarWind Virtual HCI Appliance (vHCI) [ESXi]':
                case 'StarWind Virtual HCI Appliance (vHCI) [Hyper-V]':
                case 'StarWind Virtual HCI Appliance (vHCI) [KVM]':
                case 'Proxmox Virtual Environment [KVM]':
                    license = 'vsan_trial_hyper-v_oct18';
                    valid_vHCI_subProduct = true;
                    Scenario_202306 = subProduct;


                    break;
            }

            break;

        case 'Virtual HCI Appliance Free (VHCA)':

            category = 'StarWind VSAN 30-day Trial';

            switch (subProduct) {
                case 'vHCI Appliance Free [KVM + OLVM]':
                case 'Proxmox Virtual Environment Free [KVM]':
                case 'Red Hat oVirt Free [KVM]':
                case 'Oracle Linux Virtualization Manager Free [KVM]':
                    license = 'vsan_trial_hyper-v_oct18';
                    valid_vHCI_subProduct = true;
                    Scenario_202306 = subProduct;
            }

            break;

        case 'virtual_san':

            // url = '/form-1149-no-hypervisor-v17.js';
            category = 'StarWind VSAN 30-day Trial';


            switch (subProduct) {

                case 'Hyper-V':
                case 'ms_azure_stack_hci_hyperv':
                case 'ms_hyperv_server_hyperv':
                case 'red_hat_ovirt_kvm':
                case 'red_hat_virt_rhv_kvm':
                case 'Oracle Linux Virtualization Manager (OLVM) [KVM]':
                case 'Proxmox Virtual Environment (VE) [KVM]':
                case 'Proxmox Virtual Environment [KVM]':
                case 'bare_metal_linux_hypervisor_agnostic':
                    license = 'vsan_trial_hyper-v_oct18';
                    validVSANSubProduct = true;

                    break;

                case 'vSphere':
                    license = 'vsan_trial_vsphere_oct18';
                    validVSANSubProduct = true;

                    break;

                case 'xen_aug21':
                    license = 'xen_aug21';
                    validVSANSubProduct = true;

                    break;

            }

            switch (subProduct) {
                case 'Hyper-V':
                    Scenario_202306 = 'Hyper-V';
                    break;
                case 'ms_azure_stack_hci_hyperv':
                    Scenario_202306 = 'Microsoft Azure Stack HCI [Hyper-V]';
                    break;
                case 'ms_hyperv_server_hyperv':
                    Scenario_202306 = 'Microsoft Hyper-V Server [Hyper-V]';
                    break;
                case 'red_hat_ovirt_kvm':
                    Scenario_202306 = 'Red Hat oVirt [KVM]';
                    break;
                case 'Oracle Linux Virtualization Manager (OLVM) [KVM]':
                    Scenario_202306 = 'Oracle Linux Virtualization Manager (OLVM) [KVM]';
                    break;
                case 'Proxmox Virtual Environment (VE) [KVM]':
                case 'Proxmox Virtual Environment [KVM]':
                    Scenario_202306 = 'Proxmox Virtual Environment (VE) [KVM]';
                    break;
                case 'red_hat_virt_rhv_kvm':
                    Scenario_202306 = 'Red Hat Virtualization (RHV) [KVM]';
                    break;
                case 'bare_metal_linux_hypervisor_agnostic':
                    Scenario_202306 = 'Bare Metal Linux [Hypervisor-Agnostic]';
                    break;
            }

            break;

        case 'xen_aug21':
            // url = '/form-1149-no-hypervisor-v17.js';
            category = 'Xen-based hypervisor (XCP-NG, Citrix XenServer)';
            license = 'xen_aug21';
            break;

        case 'StarWind HCI Evaluation Kit':
            // url = '/form-nvme-of-initiator-v19.js';
            category = 'StarWind HCI Evaluation Kit';
            license = 'vsan_trial_hyper-v_oct18';
            break;

        case 'StarWind NVMe-oF Initiator':
            // url = '/form-nvme-of-initiator-v19.js';
            category = 'StarWind NVMe-oF Initiator';
            license = 'StarWind NVMe-oF Initiator';
            break;

        case 'StarWind NVMe-oF Initiator Trial':
            // url = '/form-nvme-of-initiator-v19.js';
            category = 'StarWind NVMe-oF Initiator Trial';
            license = 'StarWind NVMe-oF Initiator Trial';
            break;

        case 'vsan_free':
        case 'vsan_trial':
        case 'vsan_trial_hyper-v':
        case 'vsan_trial_hyper-v_oct18':
        case 'vsan_free_oct18':

            // url = '/form-1149-no-hypervisor-v17.js';
            category = 'StarWind VSAN Free';
            license = 'vsan_free_oct18';

            if(product === 'vsan_free_oct18') {

                if(subProduct.trim() !== '') {
                    validVSANFreeSubProduct = true;
                }

                switch (subProduct) {
                    case 'vSphere':
                     Scenario_202306 = 'VMware vSphere [ESXi]';
                        break;
                    case 'red_hat_ovirt_kvm':
                        Scenario_202306 = 'Red Hat oVirt [KVM]';
                        break;
                    case 'red_hat_virt_rhv_kvm':
                        Scenario_202306 = 'Red Hat Virtualization (RHV) [KVM]';
                        break;
                    case 'Oracle Linux Virtualization Manager (OLVM) [KVM]':
                        Scenario_202306 = 'Oracle Linux Virtualization Manager (OLVM) [KVM]';
                        break;
                    case 'Proxmox Virtual Environment [KVM]':
                        Scenario_202306 = 'Proxmox Virtual Environment [KVM]';
                        break;
                    case 'Hyper-V':
                        Scenario_202306 = 'Microsoft Windows Server [Hyper-V]';
                        break;
                    case 'ms_azure_stack_hci_hyperv':
                        Scenario_202306 = 'Microsoft Azure Stack HCI [Hyper-V]';
                        break;
                    case 'ms_hyperv_server_hyperv':
                        Scenario_202306 = 'Microsoft Hyper-V Server [Hyper-V]';
                        break;
                    case 'bare_metal_linux_hypervisor_agnostic':
                        Scenario_202306 = 'Bare Metal Linux [Hypervisor-Agnostic]';
                        break;

                }
            }

            break;

        case 'vtl':
        case'vtl_oct18':

            // url = '/form-1922-v17.js';
            category = 'StarWind Virtual Tape Library';
            license = 'vtl_oct18';

            break;

        case 'vtl_free':
        case 'vtl_free_oct18':
            // url = '/form-vtl-free-v18.js'
            category = 'StarWind Virtual Tape Library Free'
            license = 'vtl_free_oct18'

            break;


        case 'manager':
            // url = '/form-2041-v17.js';
            category = 'manager';
            license = 'manager';

            break;

        case 'web_based_management':
            // url = '/form-2083-v17.js';
            category = 'StarWind Web-based Management';
            license = 'web_based_management';
            break;

        case 'v2v':
        case 'StarWind V2V Converter':
            // url = '/form-1166-v17.js';
            category = 'v2v';
            license = 'v2v';
            break;

        case 'vsa':
            // url = '/form-1947-register-v17.js';
            category = 'vsa';
            license = 'vsa';
            break;

        case 'deduplication_analyzer':
        case 'StarWind Deduplication Analyzer':
            // url = '/form-30-v17.js';
            category = 'StarWind Dedupe Analyzer';
            license = 'deduplication_analyzer';
            break;

        case 'tape_redirector':
        case 'tape_redirector_oct18':
        case 'StarWind Tape Redirector':
            // url = '/form-39-v17.js';
            category = 'Tape Redirector';
            license = 'tape_redirector_oct18';
            break;

        case 'free-nas-san':
        case 'san-nas-trial':

            if(subProduct.trim() !== '') {
                validSANNASSubProduct = true;
            }

            Scenario_202306 = subProduct
            // console.log('Scenario_202306 = subProduct',  product, Scenario_202306, subProduct)

            // url = '/form-free-nas-san.js';
            category = 'SAN NAS';
            license = 'san-nas-trial';
            break;

        case 'san-nas-free':
            // url = '/form-free-nas-san.js';
            category = 'SAN NAS';
            license = 'san-nas-free';

            if(subProduct.trim() !== '') {
                validSANNASSubProduct = true;
            }

            Scenario_202306 = subProduct
            // console.log('Scenario_202306 = subProduct',  product, Scenario_202306, subProduct)


            break;

        case 'vtl_cloud':
        case 'trial-vtl-to-cloud_oct18':
        case 'StarWind Cloud VTL for AWS and Veeam':
            // url = '/form-1998-v17.js';
            category = 'VTL Cloud';
            break;

        case 'ram_disk':
        case 'StarWind RAM Disk':
            // url = '/form-ramdisk-v17.js';
            category = 'RAM Disk';
            license = 'ram_disk';
            break;

        case 'iscsi_initiator':
            // url = '/form-iscsi-initiator-v17.js';
            category = 'StarWind iSCSI Initiator';
            license = 'iscsi_initiator';
            break;

        case 'backblaze':
        case 'backblaze_oct18':
        case 'StarWind Storage Gateway for Backblaze':
            // url = '/form-backblaze-v17.js';
            category = 'StarWind Storage Gateway for Backblaze';
            break;


        case 'wasabi':
        case 'wasabi_oct18':
        case 'StarWind Storage Gateway for Wasabi':
            // url = '/form-wasabi-v18.js';
            category = 'StarWind Storage Gateway for Wasabi';
            break;

        case 'starwind_rPerf':
        case 'StarWind rPerf':
            // url = '/form-rperf-v18.js';
            category = 'StarWind rPerf';
            license = 'starwind_rPerf';
            break;

        case 'Nutanix vs. StarWind Battlecard':
            // url = '/form-nutanix-battlecard-v22.js';
            category = 'Nutanix vs. StarWind Battlecard';
            license = 'Nutanix vs. StarWind Battlecard';
            break;

        case 'iSCSI_Accelerator':
        case 'StarWind iSCSI Accelerator':
            // url = '/form-iscsi-accelerator-v18.js';
            category = 'StarWind iSCSI Accelerator';
            license = 'iSCSI_Accelerator';
            break;

        case 'StarWind x Proxmox VE SAN Integration Services':
            // url = '/form-iscsi-accelerator-v18.js';
            category = 'StarWind x Proxmox VE SAN Integration Services';
            license = 'StarWind x Proxmox VE SAN Integration Services';
            break;

        // default:
        //     url = 'unknown license';
        //     break;

    }

    return {
        // url: url,
        // license: license,
        // category: category,
        // Scenario_202306: Scenario_202306,
        url,
        license,
        category,
        Scenario_202306,

        validVSANSubProduct,
        validVSANFreeSubProduct,
        validSANNASSubProduct,
        valid_vHCI_subProduct,
    };


}
